import {
  QueryFilter as ProQueryFilter,
  type QueryFilterProps,
} from "@ant-design/pro-components";
import { Grid } from "antd";
import classNames from "classnames";
import React from "react";

function ResponsiveQueryFilter<T = Record<string, any>>(
  props: QueryFilterProps<T>,
) {
  const {
    className,
    collapsed: controlledCollapsed,
    defaultCollapsed = true,
    onCollapse,
    ...rest
  } = props;
  const screens = Grid.useBreakpoint();
  const isSmallScreen = !screens.md;
  const [innerCollapsed, setInnerCollapsed] = React.useState<boolean>(
    controlledCollapsed ?? defaultCollapsed,
  );

  React.useEffect(() => {
    if (controlledCollapsed !== undefined) {
      setInnerCollapsed(controlledCollapsed);
    }
  }, [controlledCollapsed]);

  const mergedCollapsed =
    controlledCollapsed !== undefined ? controlledCollapsed : innerCollapsed;

  const handleCollapse = React.useCallback(
    (nextCollapsed: boolean) => {
      if (controlledCollapsed === undefined) {
        setInnerCollapsed(nextCollapsed);
      }
      onCollapse?.(nextCollapsed);
    },
    [controlledCollapsed, onCollapse],
  );

  return (
    <ProQueryFilter<T>
      {...rest}
      className={classNames(className, {
        "mobile-query-filter-collapsed": isSmallScreen && mergedCollapsed,
      })}
      collapsed={mergedCollapsed}
      defaultCollapsed={defaultCollapsed}
      onCollapse={handleCollapse}
    />
  );
}

export type { QueryFilterProps };
export default ResponsiveQueryFilter;
